import {
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useMediaQuery } from "react-responsive";
import "bulma/css/bulma.css";
import { Link } from "react-router-dom";
import "../../../../../index.css";
import "./matpelTeacher.css";
// import "./cleanMinimalTable.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { APISD } from "../../../../../config/apisd";
import { APIMS } from "../../../../../config/apims";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
  faArrowLeft,
  faBookOpen,
  faBook,
  faChalkboardTeacher,
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";

import SilabusTab from "./tabs/Silabus";
import MateriTab from "./tabs/Materi";
import UlanganTab from "./tabs/Ulangan";

import NilaiKhususTab from "./tabs/NilaiKhusus";
import KegiatanTab from "./tabs/Kegiatan";

import TpPage from "./subpage/TpPage";
import DetailUlanganPage from "./subpage/DetailUlanganPage";
import AspekKegiatanPage from "./tabs/Aspek";

import DetailNilaiKhususPage from "./subpage/DetailNilaiKhususPage";

export default function MataPelajaran() {
  document.title = "Mata Pelajaran";

  const isTabletOrMobile = useMediaQuery({
    query: "(max-width: 780px)",
  });

  const [isFetching, setIsFetching] = useState(true);

  const [selectedMatpel, setSelectedMatpel] = useState(null);
  const [selectedCp, setSelectedCp] = useState(null);
  const [selectedUlangan, setSelectedUlangan] = useState(null);
  const [selectedKegiatan, setSelectedKegiatan] = useState(null);

  const [selectedNilaiKhusus, setSelectedNilaiKhusus ] = useState(null);

  const [activeMatpelTab, setActiveMatpelTab] =
    useState("silabus");

  const [searchKeyword, setSearchKeyword] = useState("");

  const [getData, setGetData] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [semesterOptions, setSemesterOptions] = useState([]);

  const [academicYear, setAcademicYear] = useState("");
  const [semesterName, setSemesterName] = useState("");

  const [selectedSemesterId, setSelectedSemesterId] =
    useState("");

  const [
    selectedAcademicYearId,
    setSelectedAcademicYearId,
  ] = useState("");

  const getToken = () => {
    return localStorage.getItem("token") || "";
  };

  const getUserId = () => {
    return (
      localStorage
        .getItem("id_admin")
        ?.replace(/[|&;$%@"<>()+,]/g, "") ||
      localStorage
        .getItem("user_id")
        ?.replace(/[|&;$%@"<>()+,]/g, "") ||
      ""
    );
  };

  const getLoginUser = () => {
    const keys = [
      "user",
      "user_data",
      "data_user",
      "auth_user",
    ];

    for (const key of keys) {
      try {
        const raw = localStorage.getItem(key);

        if (raw) {
          return JSON.parse(raw);
        }
      } catch (error) {
        // Lewati data localStorage yang bukan JSON.
      }
    }

    return {};
  };

  const getTeacherId = () => {
    const user = getLoginUser();

    return (
      localStorage.getItem("teacherID") ||
      localStorage.getItem("id_teacher") ||
      localStorage.getItem("ysb_teacher_id") ||
      user?.teacherID ||
      user?.id_teacher ||
      user?.ysb_teacher_id ||
      user?.teacher_id ||
      user?.teacher?.id ||
      user?.teacher_data?.id ||
      user?.data?.teacherID ||
      user?.data?.id_teacher ||
      user?.data?.ysb_teacher_id ||
      user?.data?.teacher?.id ||
      ""
    );
  };

  const getBranchId = () => {
    const user = getLoginUser();

    return (
      localStorage.getItem("ysb_branch_id") ||
      user?.ysb_branch_id ||
      ""
    );
  };

  const getSchoolId = () => {
    const user = getLoginUser();

    return (
      localStorage.getItem("ysb_school_id") ||
      user?.ysb_school_id ||
      ""
    );
  };

  const getSemesterArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data)) {
      return responseData.data.data;
    }

    if (Array.isArray(responseData?.data)) {
      return responseData.data;
    }

    if (Array.isArray(responseData?.result)) {
      return responseData.result;
    }

    if (Array.isArray(responseData)) {
      return responseData;
    }

    return [];
  };

  const getMatpelArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data_matpel)) {
      return responseData.data.data_matpel;
    }

    if (
      Array.isArray(
        responseData?.data?.data?.data_matpel
      )
    ) {
      return responseData.data.data.data_matpel;
    }

    if (Array.isArray(responseData?.data?.ysb_matpel)) {
      return responseData.data.ysb_matpel;
    }

    if (
      Array.isArray(
        responseData?.data?.data?.ysb_matpel
      )
    ) {
      return responseData.data.data.ysb_matpel;
    }

    if (Array.isArray(responseData?.data?.data)) {
      return responseData.data.data;
    }

    if (Array.isArray(responseData?.data)) {
      return responseData.data;
    }

    if (Array.isArray(responseData?.result)) {
      return responseData.result;
    }

    if (Array.isArray(responseData)) {
      return responseData;
    }

    return [];
  };

  const getSemesterLabel = (item) => {
    return `${item?.name_year || "-"} (Semester ${
      item?.semester || "-"
    })`;
  };

  const yearOptions = useMemo(() => {
    return [
      ...new Set(
        semesters
          .map((item) => item?.name_year)
          .filter(Boolean)
      ),
    ].sort((a, b) =>
      String(b).localeCompare(String(a), "id", {
        numeric: true,
      })
    );
  }, [semesters]);

  const getSemesterData = async () => {
    setIsFetching(true);

    try {
      const token = getToken();

      const response = await APIMS.get(
        "/api/access/semesters",
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
          params: {
            page: 1,
            limit: 100,
            ascending: 0,
            search: "",
          },
        }
      );

      const rows = getSemesterArrayFromResponse(
        response?.data
      );

      const activeSemester =
        rows.find(
          (item) => Number(item?.status) === 1
        ) || rows[0];

      setSemesters(rows);

      if (activeSemester) {
        const activeYearSemesters = rows
          .filter(
            (item) =>
              item?.name_year ===
              activeSemester?.name_year
          )
          .sort(
            (a, b) =>
              Number(a?.semester) -
              Number(b?.semester)
          );

        setSemesterOptions(activeYearSemesters);
        setAcademicYear(
          activeSemester?.name_year || ""
        );
        setSemesterName(
          activeSemester?.semester || ""
        );

        setSelectedSemesterId(
          activeSemester?.id || ""
        );

        setSelectedAcademicYearId(
          activeSemester?.ysb_academic_year_id || ""
        );
      } else {
        setAcademicYear("");
        setSemesterOptions([]);
        setSemesterName("");
        setIsFetching(false);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal mengambil data semester",
      });

      setIsFetching(false);
    }
  };

  const getMatpelTeacherData = async ({
    semesterId,
    academicYearId,
  }) => {
    if (!semesterId || !academicYearId) {
      setGetData([]);
      setIsFetching(false);
      return;
    }

    setIsFetching(true);

    try {
      const token = getToken();
      const teacherId = getTeacherId();

      if (!teacherId) {
        ToastError.fire({
          icon: "error",
          title:
            "ID teacher tidak ditemukan. Silakan login ulang.",
        });

        setGetData([]);
        setIsFetching(false);
        return;
      }

      const response = await APISD.request({
        method: "GET",
        url: "/api/matpel-assignments",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        params: {
          ysb_academic_year_id: academicYearId,
          ysb_semester_id: semesterId,
          ysb_branch_id: getBranchId(),
          ysb_school_id: getSchoolId(),
          ysb_teacher_id: teacherId,
        },
      });

      const rows = getMatpelArrayFromResponse(
        response?.data
      );

      const normalizedRows = rows.flatMap(
        (item, index) => {
          const rawKelasList = Array.isArray(
            item?.kelas_list
          )
            ? item.kelas_list
            : [];

          const rawAssignments = Array.isArray(
            item?.assignments
          )
            ? item.assignments
            : [];

          const matpelId =
            item?.ysb_matpel_id ||
            item?.id ||
            `matpel-${index}`;

          const namaMatpel =
            item?.name_matpel ||
            item?.nama_matpel ||
            item?.matpel_name ||
            "-";

          const kelasList = rawKelasList.map(
            (kelas) => {
              const assignment =
                rawAssignments.find(
                  (assign) =>
                    assign?.assignment_id ===
                    kelas?.assignment_id
                );

              return {
                assignment_id:
                  kelas?.assignment_id ||
                  assignment?.assignment_id ||
                  "",

                ysb_kelas_id:
                  kelas?.ysb_kelas_id ||
                  assignment?.ysb_kelas_id ||
                  "",

                ysb_grade_level_id:
                  kelas?.ysb_grade_level_id ||
                  assignment?.ysb_grade_level_id ||
                  "",

                ysb_branch_id:
                  kelas?.ysb_branch_id ||
                  assignment?.ysb_branch_id ||
                  item?.ysb_branch_id ||
                  "",

                ysb_school_id:
                  kelas?.ysb_school_id ||
                  assignment?.ysb_school_id ||
                  item?.ysb_school_id ||
                  "",

                name_level:
                  kelas?.name_level ||
                  kelas?.["name level"] ||
                  assignment?.name_level ||
                  assignment?.["name level"] ||
                  "",

                nama_kelas:
                  kelas?.nama_kelas ||
                  kelas?.name_kelas ||
                  assignment?.name_kelas ||
                  assignment?.nama_kelas ||
                  "-",

                state_form:
                  assignment?.state_form ??
                  kelas?.state_form ??
                  1,

                raw: {
                  kelas,
                  assignment,
                },
              };
            }
          );

          const groupByLevel = kelasList.reduce(
            (acc, kelas) => {
              const levelKey =
                kelas?.name_level || "tanpa_level";

              if (!acc[levelKey]) {
                acc[levelKey] = [];
              }

              acc[levelKey].push(kelas);

              return acc;
            },
            {}
          );

          return Object.entries(groupByLevel).map(
            ([level, kelasByLevel]) => {
              const gradeLevelIds = [
                ...new Set(
                  kelasByLevel
                    .map(
                      (kelas) =>
                        kelas?.ysb_grade_level_id
                    )
                    .filter(Boolean)
                ),
              ];

              const kelasIds = [
                ...new Set(
                  kelasByLevel
                    .map(
                      (kelas) =>
                        kelas?.ysb_kelas_id
                    )
                    .filter(Boolean)
                ),
              ];

              const gradeLevelId =
                gradeLevelIds?.[0] || "";

              return {
                row_key: `${matpelId}-grade-${
                  gradeLevelId || level
                }`,

                id: matpelId,
                ysb_matpel_id: matpelId,

                ysb_grade_level_id:
                  gradeLevelId,

                selected_grade_level_ids:
                  gradeLevelIds,

                selected_kelas_ids: kelasIds,

                nama_matpel: namaMatpel,
                matpel_type: Number(item?.matpel_type ?? 0),
                name_level: level,

                nama_tingkatan:
                  level !== "tanpa_level"
                    ? `Kelas ${level}`
                    : "Tanpa Tingkatan",

                kelas_list: kelasByLevel,
                assignments: kelasByLevel,
                total_kelas: kelasByLevel.length,
                raw: item,
              };
            }
          );
        }
      );

      setGetData(normalizedRows);
    } catch (error) {
      setGetData([]);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal mengambil data mata pelajaran",
      });
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    getSemesterData();
  }, []);

  useEffect(() => {
    if (
      selectedSemesterId &&
      selectedAcademicYearId
    ) {
      getMatpelTeacherData({
        semesterId: selectedSemesterId,
        academicYearId:
          selectedAcademicYearId,
      });
    }
  }, [
    selectedSemesterId,
    selectedAcademicYearId,
  ]);

  const nameCollator = useMemo(
    () =>
      new Intl.Collator("id", {
        sensitivity: "base",
        numeric: true,
      }),
    []
  );

  const filteredData = useMemo(() => {
    const keyword = (searchKeyword || "")
      .trim()
      .toLowerCase();

    const base = !keyword
      ? getData || []
      : (getData || []).filter((item) => {
          const namaMatpel = (
            item?.nama_matpel || ""
          )
            .toString()
            .toLowerCase();

          const namaTingkatan = (
            item?.nama_tingkatan || ""
          )
            .toString()
            .toLowerCase();

          return (
            namaMatpel.includes(keyword) ||
            namaTingkatan.includes(keyword)
          );
        });

    return [...base].sort((a, b) =>
      nameCollator.compare(
        (a?.nama_matpel || "")
          .toString()
          .trim(),
        (b?.nama_matpel || "")
          .toString()
          .trim()
      )
    );
  }, [
    getData,
    searchKeyword,
    nameCollator,
  ]);

  const matpelCardCounts = useMemo(() => {
    return filteredData.reduce((counts, item) => {
      const matpelKey = (item?.nama_matpel || "-")
        .toString()
        .trim()
        .toLocaleLowerCase("id-ID");

      counts[matpelKey] = (counts[matpelKey] || 0) + 1;
      return counts;
    }, {});
  }, [filteredData]);

  const handleClickMatpel = (row) => {
    const selectedKelasIds = Array.isArray(
      row?.selected_kelas_ids
    )
      ? row.selected_kelas_ids
      : (row?.kelas_list || [])
          .map(
            (kelas) =>
              kelas?.ysb_kelas_id
          )
          .filter(Boolean);

    const selectedGradeLevelIds =
      Array.isArray(
        row?.selected_grade_level_ids
      )
        ? row.selected_grade_level_ids
        : [
            row?.ysb_grade_level_id,
          ].filter(Boolean);

    setSelectedMatpel({
      ...row,

      id:
        row?.ysb_matpel_id ||
        row?.id ||
        "",

      ysb_matpel_id:
        row?.ysb_matpel_id ||
        row?.id ||
        "",

      ysb_grade_level_id:
        row?.ysb_grade_level_id ||
        selectedGradeLevelIds?.[0] ||
        "",

      selected_grade_level_ids:
        selectedGradeLevelIds,

      selected_kelas_ids:
        selectedKelasIds,

      ysb_kelas_id:
        selectedKelasIds?.[0] || "",
    });

    setSelectedCp(null);
    setSelectedUlangan(null);
    setSelectedNilaiKhusus(null);
    setSelectedKegiatan(null);
    setActiveMatpelTab("silabus");
  };

  const handleBackToMatpel = () => {
    setSelectedMatpel(null);
    setSelectedCp(null);
    setSelectedUlangan(null);
    setSelectedNilaiKhusus(null);
    setSelectedKegiatan(null);
    setActiveMatpelTab("silabus");
  };

  const handleBackToUlanganTab = () => {
    setSelectedUlangan(null);
    setActiveMatpelTab("ulangan");
  };

  const handleBackToNilaiKhususTab = () => {
    setSelectedNilaiKhusus(null);
    setActiveMatpelTab("buku-nilai");
  };

  /*
   * WAJIB berada sebelum conditional return.
   * Sebelumnya fungsi ini berada di bawah
   * `if (selectedMatpel)`, sehingga halaman crash.
   */
  const handleOpenAspek = (item) => {
    setSelectedKegiatan(item);
    setSelectedCp(null);
    setSelectedUlangan(null);
    setActiveMatpelTab("kegiatan");
  };

  /*
   * Saat tombol kembali pada halaman aspek diklik,
   * selectedKegiatan dikosongkan dan tab kembali
   * ke Tipe Kegiatan.
   */
  const handleBackToKegiatanTab = () => {
    setSelectedKegiatan(null);
    setActiveMatpelTab("kegiatan");
  };

  // const isKokurikulerMatpel = (
  //   selectedMatpel?.nama_matpel || ""
  // )
  //   .toString()
  //   .toLowerCase()
  //   .includes("kokurikuler");

  const isKokurikulerMatpel =
    Number(
      selectedMatpel?.matpel_type ??
        selectedMatpel?.raw?.matpel_type ??
        0
    ) === 1;


  const handleChangeSemester = (event) => {
    const semesterId =
      event.target.value;

    const semester =
      semesterOptions.find(
        (item) =>
          String(item?.id || "") ===
          String(semesterId)
      );

    setSemesterName(
      semester?.semester || ""
    );
    setSelectedSemesterId(semesterId);

    setSelectedAcademicYearId(
      semester?.ysb_academic_year_id || ""
    );

    setSelectedMatpel(null);
    setSelectedCp(null);
    setSelectedUlangan(null);
    setSelectedKegiatan(null);
    setSelectedNilaiKhusus(null);
    
    setSearchKeyword("");
  };

  const switchSemester = (semester) => {
    if (
      !semester?.id ||
      String(semester?.id) ===
        String(selectedSemesterId)
    ) {
      return;
    }

    setSemesterName(
      semester?.semester || ""
    );
    setSelectedSemesterId(
      semester?.id
    );
    setSelectedAcademicYearId(
      semester?.ysb_academic_year_id || ""
    );

    setSelectedMatpel(null);
    setSelectedCp(null);
    setSelectedUlangan(null);
    setSelectedKegiatan(null);
    setSelectedNilaiKhusus(null);
    setSearchKeyword("");
  };

  const changeYear = (event) => {
    const year = event.target.value;

    const options = semesters
      .filter(
        (item) => item?.name_year === year
      )
      .sort(
        (a, b) =>
          Number(a?.semester) -
          Number(b?.semester)
      );

    const selectedSemester =
      options.find(
        (item) => Number(item?.status) === 1
      ) || options[0];

    setAcademicYear(year);
    setSemesterOptions(options);
    setSemesterName(
      selectedSemester?.semester || ""
    );
    setSelectedSemesterId(
      selectedSemester?.id || ""
    );
    setSelectedAcademicYearId(
      selectedSemester?.ysb_academic_year_id || ""
    );

    setSelectedMatpel(null);
    setSelectedCp(null);
    setSelectedUlangan(null);
    setSelectedKegiatan(null);
    setSelectedNilaiKhusus(null);
    setSearchKeyword("");
  };

  /*
   * Halaman TP.
   * Polanya sama seperti sebelumnya.
   */
  if (selectedMatpel && selectedCp) {
    return (
      <TpPage
        selectedMatpel={selectedMatpel}
        selectedCp={selectedCp}
        setSelectedCp={setSelectedCp}
        getToken={getToken}
        getUserId={getUserId}
        nameCollator={nameCollator}
        ToastSuccess={ToastSuccess}
        ToastError={ToastError}
      />
    );
  }

  /*
   * Halaman detail ulangan.
   */
  if (
    selectedMatpel &&
    selectedUlangan
  ) {
    return (
      <DetailUlanganPage
        selectedMatpel={selectedMatpel}
        selectedUlangan={selectedUlangan}
        setSelectedUlangan={
          handleBackToUlanganTab
        }
        selectedAcademicYearId={
          selectedAcademicYearId
        }
        selectedSemesterId={
          selectedSemesterId
        }
        getToken={getToken}
        getUserId={getUserId}
        getBranchId={getBranchId}
        getSchoolId={getSchoolId}
        nameCollator={nameCollator}
        ToastSuccess={ToastSuccess}
        ToastError={ToastError}
      />
    );
  }

  if (
  selectedMatpel &&
  selectedNilaiKhusus
) {
  return (
    <DetailNilaiKhususPage
      selectedMatpel={selectedMatpel}
      selectedNilaiKhusus={
        selectedNilaiKhusus
      }
      setSelectedNilaiKhusus={
        handleBackToNilaiKhususTab
      }
      selectedAcademicYearId={
        selectedAcademicYearId
      }
      selectedSemesterId={
        selectedSemesterId
      }
      getToken={getToken}
      getUserId={getUserId}
      getBranchId={getBranchId}
      getSchoolId={getSchoolId}
      nameCollator={nameCollator}
      ToastSuccess={ToastSuccess}
      ToastError={ToastError}
    />
  );
}

  /*
   * Halaman Aspek.
   * Akan tampil saat user klik tombol Aspek
   * pada salah satu tipe kegiatan.
   */
  if (
    selectedMatpel &&
    selectedKegiatan
  ) {
    return (
      <AspekKegiatanPage
        selectedMatpel={selectedMatpel}
        selectedKegiatan={
          selectedKegiatan
        }
        onBack={
          handleBackToKegiatanTab
        }
        getToken={getToken}
        getUserId={getUserId}
        nameCollator={nameCollator}
        ToastSuccess={ToastSuccess}
        ToastError={ToastError}
      />
    );
  }

  /*
   * Halaman detail mata pelajaran beserta tab.
   */
  if (selectedMatpel) {
    return (
      <div className="body">
        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon
                  icon={faBook}
                />
              </span>

              <div>
                <h4 className="page-title-text mb-0">
                  {selectedMatpel?.nama_matpel ||
                    "Mata Pelajaran"}{" "}
                  - Kelas{" "}
                  {selectedMatpel?.name_level ||
                    "-"}
                </h4>
              </div>
            </div>

            <div className="ml-auto">
              <button
                type="button"
                className="btn btn-light"
                onClick={handleBackToMatpel}
                style={{
                  borderRadius: 12,
                  padding: "8px 14px",
                  fontWeight: 600,
                }}
              >
                <FontAwesomeIcon
                  icon={faArrowLeft}
                />{" "}
                Kembali
              </button>
            </div>
          </div>

          <nav
            aria-label="breadcrumb"
            className="custom-breadcrumb-nav mt-4"
          >
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link
                  to="#"
                  onClick={(event) => {
                    event.preventDefault();
                    handleBackToMatpel();
                  }}
                >
                  Mata Pelajaran
                </Link>
              </li>

              <li className="custom-breadcrumb-separator">
                /
              </li>

              <li
                className="custom-breadcrumb-item active"
                aria-current="page"
              >
                {selectedMatpel?.nama_matpel ||
                  "Mata Pelajaran"}{" "}
                - Kelas{" "}
                {selectedMatpel?.name_level ||
                  "-"}
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content">
          <Tabs
            key={`${selectedMatpel?.ysb_matpel_id}-${selectedMatpel?.ysb_grade_level_id}`}
            activeKey={activeMatpelTab}
            onSelect={(key) => {
              if (key) {
                setActiveMatpelTab(key);
              }
            }}
            id="tab-matpel-teacher"
            className="mb-3 nav-tabs"
            mountOnEnter
          >
            <Tab
              eventKey="silabus"
              title="Silabus"
            >
              <SilabusTab
                selectedMatpel={
                  selectedMatpel
                }
                selectedSemesterId={
                  selectedSemesterId
                }
                selectedAcademicYearId={
                  selectedAcademicYearId
                }
                getToken={getToken}
                getUserId={getUserId}
                getBranchId={getBranchId}
                getSchoolId={getSchoolId}
                setSelectedCp={
                  setSelectedCp
                }
                nameCollator={
                  nameCollator
                }
                ToastSuccess={
                  ToastSuccess
                }
                ToastError={ToastError}
              />
            </Tab>

            {isKokurikulerMatpel && (
              <Tab
                eventKey="kegiatan"
                title="Tipe Kegiatan"
              >
                <KegiatanTab
                  selectedMatpel={
                    selectedMatpel
                  }
                  selectedSemesterId={
                    selectedSemesterId
                  }
                  selectedAcademicYearId={
                    selectedAcademicYearId
                  }
                  getToken={getToken}
                  getUserId={getUserId}
                  getBranchId={
                    getBranchId
                  }
                  getSchoolId={
                    getSchoolId
                  }
                  nameCollator={
                    nameCollator
                  }
                  ToastSuccess={
                    ToastSuccess
                  }
                  ToastError={
                    ToastError
                  }
                  onOpenAspek={
                    handleOpenAspek
                  }
                />
              </Tab>
            )}

            <Tab
              eventKey="materi"
              title="Materi"
            >
              <MateriTab
                selectedMatpel={
                  selectedMatpel
                }
                selectedAcademicYearId={
                  selectedAcademicYearId
                }
                selectedSemesterId={
                  selectedSemesterId
                }
                getToken={getToken}
                getUserId={getUserId}
                getBranchId={getBranchId}
                getSchoolId={getSchoolId}
                nameCollator={
                  nameCollator
                }
                ToastSuccess={
                  ToastSuccess
                }
                ToastError={ToastError}
              />
            </Tab>

            <Tab
              eventKey="ulangan"
              title="Ulangan"
            >
              <UlanganTab
                selectedMatpel={
                  selectedMatpel
                }
                selectedAcademicYearId={
                  selectedAcademicYearId
                }
                selectedSemesterId={
                  selectedSemesterId
                }
                setSelectedUlangan={
                  setSelectedUlangan
                }
                getToken={getToken}
                getUserId={getUserId}
                getBranchId={getBranchId}
                getSchoolId={getSchoolId}
                nameCollator={
                  nameCollator
                }
                ToastSuccess={
                  ToastSuccess
                }
                ToastError={ToastError}
              />
            </Tab>

            {isKokurikulerMatpel && (
              <Tab
                eventKey="buku-nilai"
                title="Nilai Khusus"
              >
                <NilaiKhususTab
                  selectedMatpel={selectedMatpel}
                  selectedSemesterId={
                    selectedSemesterId
                  }
                  selectedAcademicYearId={
                    selectedAcademicYearId
                  }
                  getToken={getToken}
                  getUserId={getUserId}
                  getBranchId={getBranchId}
                  getSchoolId={getSchoolId}
                  nameCollator={nameCollator}
                  ToastSuccess={ToastSuccess}
                  ToastError={ToastError}
                  setSelectedNilaiKhusus={
                    setSelectedNilaiKhusus
                  }
                />
              </Tab>
            )}
          </Tabs>
        </div>
      </div>
    );
  }

  /*
   * Halaman list mata pelajaran.
   */
  return (
    <div className="body">
      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon
                icon={faBook}
              />
            </span>

            <h4 className="page-title-text">
              Mata Pelajaran
            </h4>
          </div>
        </div>
      </div>

      <div className="body-content">
        {/* <div
          className="d-flex mb-4"
          style={{
            gap: 12,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div
            className="at-search"
            style={{
              flex: 1,
              minWidth: 240,
            }}
          >
            <input
              className="at-input"
              placeholder="Cari Mata Pelajaran"
              value={searchKeyword}
              onChange={(event) =>
                setSearchKeyword(
                  event.target.value
                )
              }
            />
          </div>

          <select
            className="at-input"
            value={selectedSemesterId}
            onChange={
              handleChangeSemester
            }
            style={{
              width: isTabletOrMobile
                ? "100%"
                : 260,
              cursor: "pointer",
              background: "#fff",
            }}
          >
            <option value="">
              Pilih Semester
            </option>

            {semesterOptions.map(
              (item) => (
                <option
                  key={item?.id}
                  value={item?.id}
                >
                  {getSemesterLabel(
                    item
                  )}

                  {Number(
                    item?.status
                  ) === 1
                    ? " - Aktif"
                    : ""}
                </option>
              )
            )}
          </select>
        </div> */}

        <div className="sims-table-tab-head sims-matpel-home">
          {/* <div className="sims-table-tab-title">
            <h5>
              Semester {semesterName}
            </h5>
          </div> */}
          <select
            className="sims-filter-select sims-filter-select-mapel"
            value={academicYear}
            onChange={changeYear}
          >
            <option value="" disabled>
              Pilih Tahun Ajaran
            </option>
            {yearOptions.map((year) => (
              <option key={year} value={year}>
                {year}
                {semesters.some(
                  (item) =>
                    item?.name_year === year &&
                    Number(item?.status) === 1
                )
                  ? " - Aktif"
                  : ""}
              </option>
            ))}
          </select>
          <div className="sims-table-tab-semester-switch">
            {semesterOptions.map((semester) => (
              <button
                type="button"
                key={semester?.id}
                className={`sims-table-tab-semester ${
                  String(selectedSemesterId) ===
                  String(semester?.id)
                    ? "is-active"
                    : ""
                }`}
                onClick={() => switchSemester(semester)}
                disabled={isFetching}
              >
                Semester {semester?.semester}
              </button>
            ))}
          </div>
        </div>

        {isFetching ? (
          <div
            className="text-center"
            style={{
              padding: "30px 0",
            }}
          >
            <PulseLoader
              color="#3f5bea"
              size={10}
            />

            <div
              style={{
                marginTop: 10,
                color: "#3f5bea",
                fontWeight: 400,
                fontSize: 16,
              }}
            >
              Memuat data mata
              pelajaran...
            </div>
          </div>
        ) : (
          <>
            {filteredData.length > 0 ? (
              <div
                className="matpel-card-grid"
                style={{
                  display: "grid",

                  gridTemplateColumns:
                    isTabletOrMobile
                      ? "1fr"
                      : "repeat(2, minmax(0, 1fr))",

                  gap: 16,
                  maxWidth: "100%",
                }}
              >
                {filteredData.map(
                  (row, rowIndex) => {
                    const currentMatpelName = (
                      row?.nama_matpel || "-"
                    )
                      .toString()
                      .trim();

                    const previousMatpelName = (
                      filteredData[
                        rowIndex - 1
                      ]?.nama_matpel || ""
                    )
                      .toString()
                      .trim();

                    const showMatpelTitle =
                      rowIndex === 0 ||
                      nameCollator.compare(
                        currentMatpelName,
                        previousMatpelName
                      ) !== 0;

                    const matpelKey =
                      currentMatpelName.toLocaleLowerCase("id-ID");
                    const isSingleMatpelCard =
                      matpelCardCounts[matpelKey] === 1;

                    return (
                    <Fragment
                      key={row?.row_key}
                    >
                      {showMatpelTitle && (
                        <div
                          className={`matpel-group-title ${
                            rowIndex > 0
                              ? "matpel-group-title-spaced"
                              : ""
                          }`}
                        >
                          <span>
                            {currentMatpelName}
                          </span>

                          <div
                            className="matpel-group-line"
                            aria-hidden="true"
                          />
                        </div>
                      )}

                    <div
                      className={`matpel-card-item ${
                        isSingleMatpelCard
                          ? "matpel-card-item-full"
                          : ""
                      }`}
                      onClick={() =>
                        handleClickMatpel(
                          row
                        )
                      }
                      title="Klik untuk melihat detail mata pelajaran"
                      style={{
                        background: "#fff",
                        border:
                          "1px solid #dce6ff",
                        borderRadius: 16,
                        padding: 20,
                        cursor: "pointer",

                        boxShadow:
                          "0 8px 24px rgba(67, 104, 197, 0.08)",

                        transition:
                          "0.2s ease",
                      }}
                      onMouseEnter={(
                        event
                      ) => {
                        event.currentTarget.style.transform =
                          "translateY(-3px)";

                        event.currentTarget.style.boxShadow =
                          "0 15px 32px rgba(67, 104, 197, 0.14)";
                      }}
                      onMouseLeave={(
                        event
                      ) => {
                        event.currentTarget.style.transform =
                          "translateY(0)";

                        event.currentTarget.style.boxShadow =
                          "0 8px 24px rgba(67, 104, 197, 0.08)";
                      }}
                    >
                      <div
                        className="d-flex"
                        style={{
                          alignItems:
                            "center",
                          gap: 12,
                        }}
                      >
                        <div
                          style={{
                            width: 44,
                            height: 44,
                            borderRadius: 14,

                            background:
                              "#eef3ff",

                            color:
                              "#4665f5",

                            display: "flex",

                            alignItems:
                              "center",

                            justifyContent:
                              "center",

                            fontSize: 18,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={
                              faBookOpen
                            }
                          />
                        </div>

                        <div
                          style={{
                            minWidth: 0,
                          }}
                        >
                          <div
                            style={{
                              color:
                                "#102453",

                              fontWeight: 700,
                              fontSize: 15,
                              lineHeight: 1.3,
                            }}
                          >
                            {row?.nama_matpel ||
                              "-"}{" "}
                            -{" "}
                            {row?.nama_tingkatan ||
                              "-"}
                          </div>

                          <div
                            style={{
                              marginTop: 5,

                              color:
                                "#71809f",

                              fontSize: 12,

                              fontWeight: 500,
                            }}
                          >
                            {semesterOptions.find(
                              (item) =>
                                String(
                                  item?.id ||
                                    ""
                                ) ===
                                String(
                                  selectedSemesterId
                                )
                            )
                              ? getSemesterLabel(
                                  semesterOptions.find(
                                    (
                                      item
                                    ) =>
                                      String(
                                        item?.id ||
                                          ""
                                      ) ===
                                      String(
                                        selectedSemesterId
                                      )
                                  )
                                )
                              : "-"}
                          </div>
                        </div>
                      </div>

                      <div
                        className="d-flex mt-4"
                        style={{
                          alignItems:
                            "center",

                          justifyContent:
                            "space-between",

                          gap: 10,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",

                            alignItems:
                              "center",

                            gap: 6,

                            flexWrap:
                              "wrap",
                          }}
                        >
                          {row?.kelas_list
                            ?.length > 0 ? (
                            row.kelas_list.map(
                              (
                                kelas,
                                kelasIndex
                              ) => (
                                <span
                                  key={
                                    kelas?.ysb_kelas_id ||
                                    kelasIndex
                                  }
                                  className="matpel-class-badge"
                                  style={{
                                    display:
                                      "inline-flex",

                                    alignItems:
                                      "center",

                                    gap: 6,

                                    padding:
                                      "6px 10px",

                                    borderRadius: 999,

                                    background:
                                      "#e8f1ff",

                                    color:
                                      "#2563eb",

                                    fontSize: 12,

                                    fontWeight: 700,
                                  }}
                                >
                                  {kelas?.nama_kelas ||
                                    "-"}
                                </span>
                              )
                            )
                          ) : (
                            <span
                              style={{
                                display:
                                  "inline-flex",

                                alignItems:
                                  "center",

                                gap: 6,

                                padding:
                                  "6px 10px",

                                borderRadius: 999,

                                background:
                                  "#fee2e2",

                                color:
                                  "#b91c1c",

                                fontSize: 12,

                                fontWeight: 700,
                              }}
                            >
                              <FontAwesomeIcon
                                icon={
                                  faChalkboardTeacher
                                }
                              />

                              Belum ada kelas
                            </span>
                          )}
                        </div>

                        <span
                          // className="matpel-detail-button"
                          style={{
                            fontSize: 12,

                            color:
                              "#4665f5",

                            fontWeight: 700,

                            // whiteSpace:
                            //   "nowrap",

                            // background:
                            //   "#4665f5",

                            // borderRadius: 10,

                            // padding:
                            //   "11px 15px",
                          }}
                        >
                          Lihat Detail →
                        </span>
                      </div>
                    </div>
                    </Fragment>
                    );
                  }
                )}
              </div>
            ) : (
              <div
                className="text-center"
                style={{
                  padding:
                    "40px 20px",

                  background: "#fff",

                  borderRadius: 16,

                  border:
                    "1px dashed #cbd5e1",

                  color: "#6b7280",

                  fontWeight: 600,
                }}
              >
                Data mata pelajaran
                tidak ditemukan
              </div>
            )}

          </>
        )}
      </div>
    </div>
  );
}
